//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'
import check from '@/common/utils/check'
export default {
    methods: {
        onClose () {
            this.$emit('on-close')
        },
        submit (e) {
            try {
                const { realname, id_card_number, mobile } = e.target.value
                const data = {
                    realname,
                    id_card_number,
                    mobile
                }
                for (let key in data) {
                    if (data[key].trim() === '') {
                        this.$errorLog(`user_bind_empty_error: ${JSON.stringify(data)}${data[key]}`)
                        wx.showToast({
                            title: '您尚未填写完全',
                            icon: 'none',
                            duration: 3000
                        })
                        return
                    }
                }
                if (!check.checkIdCard(data.id_card_number)) {
                    this.$errorLog(`user_bind_id_error: ${JSON.stringify(data)}${data.id_card_number}`)
                    wx.showToast({
                        title: '身份证号格式不正确',
                        icon: 'none',
                        duration: 3000
                    })
                    return
                }
                Service.updateUserInfo(data).then(this.updateMyReg)
            } catch (e) {
                this.$errorLog(`user_bind_error: ${JSON.stringify(e)}`)
            }
        },
        updateMyReg (data) {
            if (data.code === 422) {
                wx.showToast({
                    title: data.error_message,
                    icon: 'none'
                })
            } else {
                this.$emit('on-close')
            }
        }
    },
    props: {
        show: {
            type: Boolean
        }
    }
}
